import EventScorekeepingEdit from '@/screens/EventScorekeepingEdit';

export default function PrivateTabsEventScorekeepingIndexRoute() {
  return <EventScorekeepingEdit basePath="/event" />;
}
